










































import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util'
import PageRequest from '@/store/entities/page-request'
import { Component,Prop } from 'vue-property-decorator'
import MediaBox from '@/components/media/media-box.vue'
import MediaItem from '@/store/entities/mediaItem'
import { EventBus } from '@/lib/eventbus';  

class  PageMediaRequest extends PageRequest{
    keyword:string;
    type:string;
}
@Component({
    components:{ MediaBox }
})
export default class MediaPicker extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    pagerequest:PageMediaRequest=new PageMediaRequest(); 
    uploadPercentage:number =0;      
    zindex:number=3000;
    pageSizeOpts=[
        16
    ]
    
    get totalCount(): number{
        return this.$store.state.mediapickerlist.totalCount;
    }
    get list(){
        return this.$store.state.mediapickerlist.list as Array<MediaItem>;
    };
    get loading(){
        return this.$store.state.mediapickerlist.loading;
    }
    get pageSize(){
        return this.$store.state.mediapickerlist.pageSize;
    }
    get currentPage(){
        return this.$store.state.mediapickerlist.currentPage;
    }
    get type(){
        return this.$store.state.mediapicker.type;
    }
    get listRows(){
        let itemsPerRow = 8;
        let listLength = this.list.length;
        let countrows = Math.floor(listLength / itemsPerRow);    
        if( (countrows * itemsPerRow) < listLength ){
            countrows =countrows+ 1;
        }
        return countrows;
    }
    imageRecived(imagePath,id){
        this.$emit('input',false);
        if(this.type == 0){
            EventBus.$emit('sendImageForWyswig', imagePath.fileWebPath);
        }else if (this.type == 1){
            EventBus.$emit('sendImageForBoxImage', imagePath);
        }else if( this.type == 2){
            EventBus.$emit('sendImageForOptions', imagePath);
        }else if( this.type == 3){
            EventBus.$emit('sendImageForBoxImage2', imagePath);
        }else if( this.type == 4){
            EventBus.$emit('sendImageForBoxImage2', imagePath);
        }           
    }
    destroyed(){
        this.value = false;
    }
    save(){

    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    cancel(){
        (this.$refs.pageForm as any).resetFields();
        this.$emit('input',false);
    }
    uploadFile(efile){
        let formData = new FormData();;
        formData.append('responsibleUserId', Util.abp.session.userId);
        for(let index=0; index<1; index++)
        {
            formData.append('files', efile);
        } 
        this.$store.dispatch({
            type: "mediamanager/createMediaItems",
            data: formData
        }).then( ()=> {
            this.getpage();
        });
        return false;
    }
    pageChange(page:number){
        this.$store.commit('mediapickerlist/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('mediapickerlist/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){     
        this.$store.commit('mediapickerlist/setPageSize',this.pageSize);                   
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        this.pagerequest.type ="image"
        //filters            
        await this.$store.dispatch({
            type:'mediapickerlist/getAll',
            data:this.pagerequest
        })
    }

    columns=[
    {            
        title:this.L('File'),
        width:80,
        render:(h:any,params:any)=>{
            let attrs = {"src":params.row.fileWebPath,"width":75,"height":75,"padding-top":"4px"};
            return h('img',{attrs});
        }
    },
    {
        title:this.L('FileName'),
        key:'fileName'
    },
    {
        title:this.L('ResponsibleUserName'),
        key:'responsibleUserName'
    },{
        title:this.L('Description'),
        key:'description'
    }
    ,{
        title:this.L('Actions'),
        key:'Actions',
        width:150,
        render:(h:any,params:any)=>{
            return h('div',[                   
                h('Button',{
                    props:{
                        type:'error',
                        icon:'md-trash',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('DeleteMediaConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'mediapickerlist/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },)
            ])
        }
    }]
    async search(){
        this.$store.commit('mediapickerlist/setCurrentPage',1);
        this.getpage();
    }
    async created(){  
        this.$store.commit('mediapickerlist/setCurrentPage',1);
        this.$store.commit('mediapickerlist/setPageSize',16); 
        this.getpage();
    }
};
